import './App.css';
import { MathFactsGenerator } from './MathFactsGenerator/MathFactsGenerator.tsx';
import { SideNav } from './SideNav/SideNav.tsx';
import { OneHundredChart } from './Charts/OneHundredChart.tsx';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ProcessUrl } from './MathFactsGenerator/UrlProcessor/ProcessUrl.tsx';
import { DefaultSettings } from './MathFactsGenerator/Models.ts';
import { MultiplicationChart } from './Charts/MultiplicationChart.tsx';
import { LandingPage } from './Landing/LandingPage.tsx';
import { landingRoutes } from './Shared/Seo/routeSeo.ts';

function App() {

  const urlQuery = window.location.search;
  let initialSettings = DefaultSettings;
  if (urlQuery) {
    initialSettings = ProcessUrl(urlQuery);
  }

  // All MathFactsGenerator routes are driven by the manifest (routeSeo.json).
  // Adding a new operation landing page is a data-only change in that file.
  const landings = landingRoutes();

  return (
    <div className="App">
      <div>
        <Router>
          <SideNav/>
          <Routes>
            {/* Home: shared URL-state entry point */}
            <Route exact path="" element={
              <MathFactsGenerator initialSettings={initialSettings}/>
            }/>

            {/* Canonical SEO landing pages (keyword slugs) — from manifest */}
            {landings.map((route) => (
              <Route key={route.slug} path={route.slug} element={
                <LandingPage slug={route.slug}/>
              }/>
            ))}

            {/* Legacy path → canonical slug redirects — from manifest */}
            {landings.flatMap((route) =>
              (route.legacyPaths ?? []).map((legacy) => (
                <Route key={legacy} path={legacy} element={
                  <Navigate to={route.slug} replace/>
                }/>
              ))
            )}

            {/* Chart routes use separate components, not the manifest generator */}
            <Route path="/counting/OneHundredChart" element={<OneHundredChart/>}/>
            <Route path="/multiplication/multiplicationChart" element={<MultiplicationChart/>}/>
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
